import { render, staticRenderFns } from "./searchItem.vue?vue&type=template&id=1858980d&"
import script from "./searchItem.vue?vue&type=script&lang=ts&"
export * from "./searchItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports